import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "The Backbone of Every Build",
    body: "From a single length of MS pipe to truckloads of TMT rods, we supply the steel that holds up homes, factories and everything in between. Cut to order, weighed in front of you.",
  },
  {
    num: "02",
    title: "Fair Weight. Fair Price.",
    body: "No games on the scale, no surprises on the bill. Rates move with the market and we tell you straight — whether you're buying new steel or selling us a yard full of scrap.",
  },
  {
    num: "03",
    title: "Scrap In. Steel Out.",
    body: "We buy iron, plastic and vehicle scrap — and we sell it too. One yard, both directions. Bring your old metal, leave with cash or fresh stock.",
  },
];

export default function Manifesto() {
  return (
    <section className="border-b border-[#262626] px-6 md:px-12 py-32 md:py-48" data-testid="manifesto-section">
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
        className="text-xs uppercase tracking-[0.35em] text-[#525252] mb-16"
      >
        The Yard Manifesto
      </motion.p>

      <div className="space-y-24 md:space-y-32">
        {chapters.map((c, i) => (
          <motion.div
            key={c.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-120px" }}
            transition={{ duration: 0.9, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 items-start"
            data-testid={`manifesto-chapter-${c.num}`}
          >
            <span className="md:col-span-2 font-display text-5xl md:text-7xl text-outline leading-none">
              {c.num}
            </span>
            <h2 className="md:col-span-5 font-display text-3xl md:text-5xl uppercase leading-[0.95] tracking-tight text-steel-soft">
              {c.title}
            </h2>
            <p className="md:col-span-5 text-sm md:text-base text-[#a3a3a3] leading-relaxed md:pt-3">
              {c.body}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
